import {IFlatBoosterParams} from "../types/booster_generic/IFlatBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {flatAreaBooster} from "./flat/flat_area_booster";
import {flatBalconyBooster} from "./flat/flat_balcony_booster";
import {flatBDIncreasedInterestBooster} from "./flat/flat_bd_increased_interest_booster";
import {flatBDViewsLast3daysBooster} from "./flat/flat_bd_views_last_3days_booster";
import {flatFloorBooster} from "./flat/flat_floor_booster";
import {flatGarageBooster} from "./flat/flat_garage_booster";
import {flatRoomsBooster} from "./flat/flat_rooms_booster";
import {flatTerraceBooster} from "./flat/flat_terrace_booster";
import {houseQuarterEastBooster} from "./house/house_quarter_east_booster";
import {houseQuarterNorthBooster} from "./house/house_quarter_north_booster";
import {houseQuarterSouthBooster} from "./house/house_quarter_south_booster";
import {houseQuarterWestBooster} from "./house/house_quarter_west_booster";
import {promotionDiscountBooster} from "./promotions/promotion_discount_booster";
import {promotionExhibitionBooster} from "./promotions/promotion_exhibition_booster";
import {promotionLastMinuteBooster} from "./promotions/promotion_last_minute_booster";
import {promotionNoContributionBooster} from "./promotions/promotion_no_contribution_booster";
import {promotionOpenDaysBooster} from "./promotions/promotion_open_days_booster";
import {promotionPresaleBooster} from "./promotions/promotion_presale_booster";
import {promotionPromotionBooster} from "./promotions/promotion_promotion_booster";

export const flatBoostersConfig: IGenericBoostersConfig<IFlatBoosterParams> = {
    [IBoosterCategory.Promotion]: {
        [promotionPromotionBooster.type]: promotionPromotionBooster,
        [promotionOpenDaysBooster.type]: promotionOpenDaysBooster,
        [promotionDiscountBooster.type]: promotionDiscountBooster,
        [promotionLastMinuteBooster.type]: promotionLastMinuteBooster,
        [promotionPresaleBooster.type]: promotionPresaleBooster,
        [promotionExhibitionBooster.type]: promotionExhibitionBooster,
        [promotionNoContributionBooster.type]: promotionNoContributionBooster
    },
    [IBoosterCategory.OfferStats]: {
        [flatAreaBooster.type]: flatAreaBooster,
        [flatRoomsBooster.type]: flatRoomsBooster,
        [flatTerraceBooster.type]: flatTerraceBooster,
        [flatGarageBooster.type]: flatGarageBooster,
        [flatFloorBooster.type]: flatFloorBooster,
        [flatBalconyBooster.type]: flatBalconyBooster,
        [houseQuarterEastBooster.type]: houseQuarterEastBooster,
        [houseQuarterNorthBooster.type]: houseQuarterNorthBooster,
        [houseQuarterSouthBooster.type]: houseQuarterSouthBooster,
        [houseQuarterWestBooster.type]: houseQuarterWestBooster
    },
    [IBoosterCategory.BigDataStats]: {
        [flatBDIncreasedInterestBooster.type]: flatBDIncreasedInterestBooster,
        [flatBDViewsLast3daysBooster.type]: flatBDViewsLast3daysBooster
    }
};
import {IFlatBoosterParams} from "../types/booster_generic/IFlatBooster";
import {IBoosterCategory} from "../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {flatAreaBooster} from "./flat/flat_area_booster";
import {flatBalconyBooster} from "./flat/flat_balcony_booster";
import {flatBDIncreasedInterestBooster} from "./flat/flat_bd_increased_interest_booster";
import {flatBDViewsLast3daysBooster} from "./flat/flat_bd_views_last_3days_booster";
import {flatFloorBooster} from "./flat/flat_floor_booster";
import {flatGarageBooster} from "./flat/flat_garage_booster";
import {flatRoomsBooster} from "./flat/flat_rooms_booster";
import {flatTerraceBooster} from "./flat/flat_terrace_booster";
import {houseQuarterEastBooster} from "./house/house_quarter_east_booster";
import {houseQuarterNorthBooster} from "./house/house_quarter_north_booster";
import {houseQuarterSouthBooster} from "./house/house_quarter_south_booster";
import {houseQuarterWestBooster} from "./house/house_quarter_west_booster";
import {promotionDiscountBooster} from "./promotions/promotion_discount_booster";
import {promotionExhibitionBooster} from "./promotions/promotion_exhibition_booster";
import {promotionLastMinuteBooster} from "./promotions/promotion_last_minute_booster";
import {promotionNoContributionBooster} from "./promotions/promotion_no_contribution_booster";
import {promotionOpenDaysBooster} from "./promotions/promotion_open_days_booster";
import {promotionPresaleBooster} from "./promotions/promotion_presale_booster";
import {promotionPromotionBooster} from "./promotions/promotion_promotion_booster";

export const flatBoostersConfig: IGenericBoostersConfig<IFlatBoosterParams> = {
    [IBoosterCategory.Promotion]: {
        [promotionPromotionBooster.type]: promotionPromotionBooster,
        [promotionOpenDaysBooster.type]: promotionOpenDaysBooster,
        [promotionDiscountBooster.type]: promotionDiscountBooster,
        [promotionLastMinuteBooster.type]: promotionLastMinuteBooster,
        [promotionPresaleBooster.type]: promotionPresaleBooster,
        [promotionExhibitionBooster.type]: promotionExhibitionBooster,
        [promotionNoContributionBooster.type]: promotionNoContributionBooster
    },
    [IBoosterCategory.OfferStats]: {
        [flatAreaBooster.type]: flatAreaBooster,
        [flatRoomsBooster.type]: flatRoomsBooster,
        [flatTerraceBooster.type]: flatTerraceBooster,
        [flatGarageBooster.type]: flatGarageBooster,
        [flatFloorBooster.type]: flatFloorBooster,
        [flatBalconyBooster.type]: flatBalconyBooster,
        [houseQuarterEastBooster.type]: houseQuarterEastBooster,
        [houseQuarterNorthBooster.type]: houseQuarterNorthBooster,
        [houseQuarterSouthBooster.type]: houseQuarterSouthBooster,
        [houseQuarterWestBooster.type]: houseQuarterWestBooster
    },
    [IBoosterCategory.BigDataStats]: {
        [flatBDIncreasedInterestBooster.type]: flatBDIncreasedInterestBooster,
        [flatBDViewsLast3daysBooster.type]: flatBDViewsLast3daysBooster
    }
};
